import * as api from '@/backend/api'
import { errorMessages, isErrorResponse, parseError } from '@/backend/error'
import type { ApiResult } from '@/backend/darwin/types'

export const leaveTeam = async (membershipId: number): Promise<ApiResult<void>> => {
  try {
    await api.remove(`memberships/${membershipId}`)
  } catch (error) {
    if (!isErrorResponse(error)) {
      throw error
    }
    return {
      ...parseError(error, errorMessages.TEAM_LEAVE),
      ok: false,
    }
  }

  return { ok: true, data: undefined }
}
